const XLSX = require("xlsx");
const moment = require("moment");

module.exports.exportActivityUsers = (active_graph, range, date) => {
  let header = null;
  if (range === 1) {
    header = { x: "Hour", y: "Active Users", z: "New Users" };
  } else if (range === 2) {
    header = { x: "Date", y: "Active Users", z: "New Users" };
  } else if (range === 3) {
    header = { x: "Month", y: "Active Users", z: "New Users" };
  }

  const { labels, datasets } = active_graph;
  const active_users = datasets[0].data;
  const new_users = datasets[1].data;

  let dataPoints = [];

  for (let i = 0; i < labels.length; i += 1) {
    dataPoints.push({ x: labels[i], y: active_users[i], z: new_users[i] });
  }

  dataPoints.unshift(header);

  let ws = XLSX.utils.json_to_sheet(dataPoints, {
    skipHeader: true,
    dateNF: "YYYYMMDD HH:mm:ss",
  });
  if (!ws["!cols"]) ws["!cols"] = [];
  ws["!cols"][0] = { wch: 17 };
  let wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, moment(date).format("YYYY-MM-DD"));
  XLSX.writeFile(wb, moment(date).format("YYYY-MM-DD") + ".xlsx");
};

module.exports.exportActivityUserRate = (all_users, active_users) => {
  const header = { x: "All Users", y: "Active Users" };
  let dataPoints = [{ x: all_users, y: active_users }];

  dataPoints.unshift(header);

  let ws = XLSX.utils.json_to_sheet(dataPoints, {
    skipHeader: true,
    dateNF: "YYYYMMDD HH:mm:ss",
  });
  if (!ws["!cols"]) ws["!cols"] = [];
  ws["!cols"][0] = { wch: 17 };
  let wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, moment().format("YYYY-MM-DD"));
  XLSX.writeFile(wb, moment().format("YYYY-MM-DD") + ".xlsx");
};

module.exports.exportNumericReport = (numeric_reports) => {
  const header = { x: "Description", y: "Number" };

  let labels = [];
  let numbers = [];
  for (let i = 0; i < numeric_reports.length; i += 1) {
    labels.push(numeric_reports.label);
    numbers.push(numeric_reports.number);
  }
  let dataPoints = [{ x: labels, y: numbers }];

  dataPoints.unshift(header);

  let ws = XLSX.utils.json_to_sheet(dataPoints, {
    skipHeader: true,
    dateNF: "YYYYMMDD HH:mm:ss",
  });
  if (!ws["!cols"]) ws["!cols"] = [];
  ws["!cols"][0] = { wch: 17 };
  let wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, moment().format("YYYY-MM-DD"));
  XLSX.writeFile(wb, moment().format("YYYY-MM-DD") + ".xlsx");
};



// WEBPACK FOOTER //
// ./client/react/common/utils/exportTo.js